export default "/images/fab14c5a639fe957d34064e910746e31.avif";